export enum PersonnelsPath {
  LISTE = '',
  EDITION = 'edition-personnel',
  EDITION_GENERAL = 'general',
  CREATION = 'creation-personnel',
  ID_PERSONNEL_PARAM_MAP = 'idPersonnel',
  EDITION_UTILISATEUR = 'edition-utilisateur'
}
